// @ts-nocheck
const objectKeys = <T extends {}>(object: T | undefined | null) => {
    if (!object) {
        return undefined;
    }

    return Object.keys(object) as Array<keyof T>;
};

export default objectKeys;
